import React, { FC } from 'react'
import { use100vh } from 'react-div-100vh'
import { useDispatch } from 'react-redux'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { RedLogo, SentMailIcon } from 'components/Image'
import { Spacer } from 'components/Utility'
import { OrangeButton } from 'components/Button'
import { push } from 'connected-react-router'

const ForgetTemplate: FC = () => {
  const dispatch = useDispatch()
  const height = use100vh()

  return (
    <div className={styles.forget} style={{ height: height ?? '100vh' }}>
      <RedLogo />
      <Spacer size={32} />
      <div className={styles.forget__inner}>
        <SentMailIcon />
        <Spacer size={12} />
        <Spacer size={20} />
        <p className={`${text.font_medium} ${text.align_center}`}>
          メールアドレス宛にパスワードのリセットリンクをお送りいたしました。
        </p>
        <Spacer size={40} />
        <OrangeButton
          label={'トップページに戻る'}
          onClick={() => dispatch(push('/login'))}
          size={'medium'}
          type={'main'}
        />
      </div>
    </div>
  )
}

export default ForgetTemplate
